import { useEffect, useState } from 'react';
import API from '../api/api';
import {
  TextField,
  Button,
  Typography,
  Box,
  Stack,
  Divider,
  MenuItem,
} from '@mui/material';
import { useSnackbar } from '../contexts/SnackbarContext';

const inputSx = {
  backgroundColor: 'var(--input-bg)',
  borderRadius: 2,
  '& .MuiInputBase-input': {
    color: '#000',
  },
};

export default function TireForm({ onSuccess }) {
  const { showSnackbar } = useSnackbar();
  const [suppliers, setSuppliers] = useState([]);
  const [form, setForm] = useState({
    reference: '',
    manufacturer: '',
    supplier_id: '',
    purchase_price: '',
    sale_price: '',
    initial_stock: '',
  });

  const fetchSuppliers = async () => {
    try {
      const res = await API.get('/suppliers');
      setSuppliers(res.data || []);
      if (res.data.length > 0) {
        setForm((prev) => ({
          ...prev,
          supplier_id: prev.supplier_id || String(res.data[0].id),
        }));
      }
    } catch (err) {
      showSnackbar(err.response?.data?.message || 'Erreur lors du chargement des fournisseurs', 'error');
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await API.post('/tires', {
        ...form,
        supplier_id: form.supplier_id ? Number(form.supplier_id) : null,
        purchase_price: Number(form.purchase_price),
        sale_price: Number(form.sale_price),
        initial_stock: Number(form.initial_stock),
      });

      setForm({
        reference: '',
        manufacturer: '',
        supplier_id: '',
        purchase_price: '',
        sale_price: '',
        initial_stock: '',
      });

      showSnackbar('Pneu cree avec succes', 'success');
      onSuccess && onSuccess();
    } catch (err) {
      showSnackbar(err.response?.data?.message || 'Erreur lors de la creation', 'error');
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Ajouter un nouveau pneu
      </Typography>
      <Typography color="text.secondary" mb={3}>
        Informations du pneu et stock initial
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={3}>
          {/* Infos */}
          <Stack spacing={2}>
            <TextField
              label="Reference"
              name="reference"
              value={form.reference}
              onChange={handleChange}
              required
              fullWidth
              sx={inputSx}
            />

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField
                label="Fabricant"
                name="manufacturer"
                value={form.manufacturer}
                onChange={handleChange}
                fullWidth
                sx={inputSx}
              />
            </Stack>

            <TextField
              select
              label="Fournisseur"
              name="supplier_id"
              value={form.supplier_id}
              onChange={handleChange}
              required
              fullWidth
              sx={inputSx}
            >
              {suppliers.map((supplier) => (
                <MenuItem key={supplier.id} value={String(supplier.id)}>
                  {supplier.name}
                </MenuItem>
              ))}
            </TextField>
          </Stack>

          <Divider />

          {/* Stock */}
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
            <TextField
              label="Prix d'achat (EUR)"
              name="purchase_price"
              type="number"
              value={form.purchase_price}
              onChange={handleChange}
              fullWidth
              sx={inputSx}
            />
            <TextField
              label="Prix de vente (EUR)"
              name="sale_price"
              type="number"
              value={form.sale_price}
              onChange={handleChange}
              fullWidth
              sx={inputSx}
            />
            <TextField
              label="Stock initial"
              name="initial_stock"
              type="number"
              value={form.initial_stock}
              onChange={handleChange}
              fullWidth
              sx={inputSx}
            />
          </Stack>

          <Box
            display="flex"
            justifyContent={{ xs: 'stretch', sm: 'flex-end' }}
          >
            <Button
              type="submit"
              variant="contained"
              size="large"
              sx={{
                px: { xs: 2, sm: 4 },
                borderRadius: 3,
                fontWeight: 600,
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Creer le pneu
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}


